import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { RawHtmlInterface } from 'common/types/entities/RawHtmlInterface'
import { EntitiesStructure } from 'common/types/Page'
import { DiagnosticFinding, DiagnosticRule } from '../types'

const SCRIPT_PATTERNS = [
  /<script/i,
  /<iframe/i,
  /\bonclick\b/i,
  /\bonerror\b/i,
  /\bonload\b/i,
  /\bonmouseover\b/i,
  /\bonsubmit\b/i,
  /\bonchange\b/i,
  /javascript:/i,
  /eval\s*\(/i,
  /document\.(write|cookie|location)/i,
]

function hasScriptLikeContent(html: string): boolean {
  return SCRIPT_PATTERNS.some(pattern => pattern.test(html))
}

export const rawHtmlRule: DiagnosticRule = {
  id: 'raw-html',
  name: 'Raw HTML',
  run: (entities: EntitiesStructure): DiagnosticFinding[] => {
    const findings: DiagnosticFinding[] = []

    for (const entity of Object.values(entities)) {
      if (entity.type !== EntityTypeEnum.RawHtml) {
        continue
      }

      const html = (entity as RawHtmlInterface).html || ''
      const isScriptLike = html.length > 0 && hasScriptLikeContent(html)

      findings.push({
        ruleId: 'raw-html',
        severity: isScriptLike ? 'warning' : 'info',
        entityId: entity.id,
        entityType: EntityTypeEnum.RawHtml,
        message: isScriptLike
          ? 'RawHtml contains script-like content'
          : 'RawHtml entity present',
        metadata: { hasScriptContent: isScriptLike },
      })
    }

    return findings
  },
}
